import { FC, ReactNode } from "react";

import { cn } from "@/lib/utils";

import { AdvisorMissingOutCard } from "./AdvisorMissingOutCard";

export interface AdvisorMissingOutOverlayProps {
  children: ReactNode;
  showOverlay: boolean;
  onButtonClick: () => void;
  onClose?: () => void;
  title?: string;
  description?: string;
  subtitle?: string;
  buttonText?: string;
  buttonColor?: string;
  overlayColor?: string;
  className?: string;
}

export const AdvisorMissingOutOverlay: FC<AdvisorMissingOutOverlayProps> = ({
  children,
  showOverlay,
  onButtonClick,
  onClose,
  title,
  description,
  subtitle,
  buttonText,
  buttonColor,
  overlayColor = "rgba(0, 0, 0, 0.3)",
  className,
}) => {
  return (
    <div className={cn("relative", className)}>
      {children}

      {showOverlay && (
        <div
          className="absolute inset-0 z-10 flex items-center justify-center py-8"
          style={{ backgroundColor: overlayColor }}
        >
          <div style={{ width: "85%" }}>
            <AdvisorMissingOutCard
              onButtonClick={onButtonClick}
              onClose={onClose}
              title={title}
              description={description}
              subtitle={subtitle}
              buttonText={buttonText}
              buttonColor={buttonColor}
            />
          </div>
        </div>
      )}
    </div>
  );
};
